export const SHERLOCK_CHANGES = {
  buying_price: "CPC",
  greediness: "Greediness",
  max_clicks_last_24h: "Max Clicks Last 24h",
  max_impressions_last_24h: "Max Impressions Last 24h",
  budget_pool_id: "Budget Pool Id",
  segment_membership: "Segment Membership",
  target_margin: "Target Margin",
  cycle_length: "Cycle Length",
  cycle_amount: "Cycle Amount",
  conversion_cpx: "Conversion Cpx",
  target_incremental_roas: "Target Incremental Roas",
  target_incremental_cpx: "Target Incremental Cpx",
  target_roas: "Target Roas",
  other_goals: "Other Goals",
  bid_multiplier_automation_enabled: "Bid Multiplier Automation Enabled",
  uplift_control_group_share: "Uplift Control Group Share",
  view_to_reengagement_window: "View To Reengagement Window",
  click_to_reengagement_window: "Click To Reengagement Window",
} as const;

export type SherlockChangeType = keyof typeof SHERLOCK_CHANGES;

export const METRICS_TO_DISPLAY = {
  ap_conversions: "AP Conversions",
  spend: "Spend",
  XPC: "XPC",
} as const;

export type SherlockMetricType = keyof typeof METRICS_TO_DISPLAY;

export type SherlockAttributeValue = string | number | boolean; // TODO: double check this

export type SherlockChangeDetails = {
  sherlock_change_id: string | null;
  changed_attribute: SherlockChangeType;
  prev_value: SherlockAttributeValue;
  new_value: SherlockAttributeValue;
  date: Date;
};

export type SherlockDruidDataAttributes = {
  x: string;
  y: string;
  events: SherlockChangeDetails[];
};

export type SherlockDruidResponse = SherlockDruidDataAttributes[];

export type SherlockImpact = {
  value: number;
  days: number;
  hours: number;
};

export type SherlockActualAndPredictedData = {
  baseline: SherlockDruidDataAttributes[];
  predicted_impact: SherlockDruidDataAttributes[];
  is_significant: boolean;
  impact: SherlockImpact;
  error: string | null;
};
